import React from 'react';
import {NA} from '@/constants';
import {useSelector} from 'react-redux';
import {authDataSelector} from '@/services/redux/selectors';
import {cn, getInitials} from '@/utils/common_functions';

interface ProfileProps {
  profile_url?: string;
  username?: string;
  className?: string;
  textClassname?: string;
}

export const Profile: React.FC<ProfileProps> = props => {
  const authData = useSelector(authDataSelector);
  const fallbackProfile = authData?.photo_url;
  const fallbackUsername = authData?.username || NA;


  const {profile_url=fallbackProfile, username=fallbackUsername, className, textClassname} = props;

  const initials = getInitials(username);

  if (profile_url) {
    return (
      <img
        alt="profile"
        className={cn("size-10 rounded-full object-cover bg-ui_sky_blue", className)}
        src={profile_url}
      />
    );
  }
  return (
    <div
      className={cn(
        'rounded-full flex bg-ui_sky_blue size-10 justify-center items-center cursor-pointer',
        className
      )}
    >
      <span
        className={cn(
          "text-ui_blue text-xl font-FigtreeSemiBold",
          textClassname
        )}
      >
        {initials}
      </span>
    </div>
  );

  
};
